// @systeme: interface
// La coquille des écrans connectés : le contenu, et la navigation basse.
// Sans session, on renvoie vers la connexion.
import Box from '@mui/material/Box';
import { Navigate, Outlet } from 'react-router';
import { useSession } from '../session/SessionContext';
import { tailles } from '../theme/theme';
import { Chargement } from './Chargement';
import { NavigationBasse } from './NavigationBasse';

export function Coquille() {
  const { etat } = useSession();
  if (etat.etat === 'chargement') return <Chargement />;
  if (etat.etat === 'deconnectee') return <Navigate to="/connexion" replace />;
  return (
    <Box sx={{ minHeight: '100dvh', pb: `${tailles.navigation + 24}px` }}>
      <Box component="main" sx={{ maxWidth: 560, mx: 'auto' }}>
        <Outlet />
      </Box>
      <NavigationBasse />
    </Box>
  );
}

/** Les écrans publics (connexion…) : si on est déjà connectée, direction Aujourd'hui. */
export function ZonePublique() {
  const { etat } = useSession();
  if (etat.etat === 'chargement') return <Chargement />;
  if (etat.etat === 'connectee') return <Navigate to="/" replace />;
  return (
    <Box sx={{ minHeight: '100dvh' }}>
      <Box
        component="main"
        sx={{ maxWidth: 480, mx: 'auto', px: `${tailles.marge}px`, pt: 6, pb: 4 }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
